<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
    :disabled="isCompleted"
  >
    <v-container class="text-center" v-if="stockItem">
      <CardApproval
        v-if="isCompleted"
        :createdBy="localCanningProcess.createdBy"
        :created="localCanningProcess.created"
      />
      <h1>Process Check Sheet</h1>
      <h3 v-if="stockItem">{{ stockItem.type }}</h3>
      <br />
      <div id="FormProcessCheckSheet-Header" :class="{ dimmed: localProcessCheckSheet.status }">
        <v-row>
          <!--Delivery Date-->
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormProcessCheckSheet-deliveryDate"
              :label="$$t('deliveryDate')"
              v-model="localProcessCheckSheet.deliveryDate"
              v-mask="'####-##-##'"
              hint="YYYY-MM-DD"
            />
          </v-col>
          <!--Supplier Comments-->
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormProcessCheckSheet-supplierComments"
              :label="$$t('supplierComments')"
              v-model="localProcessCheckSheet.supplierComments"
            />
          </v-col>
        </v-row>
        <v-row>
          <!--Supplier-->
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormProcessCheckSheet-supplier"
              :label="$$t('supplier')"
              v-model="localProcessCheckSheet.supplier"
            />
          </v-col>
          <!--farm grade range-->
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormProcessCheckSheet-farmGradeRange"
              :label="$$t('farmGradeRange')"
              v-model="localProcessCheckSheet.farmGradeRange"
            />
          </v-col>
          <!--Delivery Weight-->
          <v-col cols="4">
            <v-text-field
              filled
              append-icon="(kg)"
              data-cy="FormProcessCheckSheet-deliveryWeight"
              :label="$$t('deliveryWeight')"
              v-model="localProcessCheckSheet.deliveryWeight"
            />
          </v-col>
        </v-row>
      </div>
      <div id="FormProcessCheckSheet-Chiller" :class="{ dimmed: localProcessCheckSheet.status }">
        <div v-if="!isWet && !isCanned && !isPouches">
          <h3>Receiving Chiller</h3>
          <!--Third Row-->
          <v-row>
            <!--Receiving Chiller Start Time-->
            <v-col cols="3">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-receivingChillerStartTime"
                :label="$$t('receivingChillerStartTime')"
                v-model="localProcessCheckSheet.receivingChillerStartTime"
              />
            </v-col>
            <!--Start Temp-->
            <!--End Time-->
            <v-col cols="3">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-endTime"
                :label="$$t('endTime')"
                v-model="localProcessCheckSheet.endTime"
              />
            </v-col>
            <!--End temp-->
            <v-col cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-receiveTemp"
                :label="$$t('receiveTemp')"
                v-model="localProcessCheckSheet.receiveTemp"
              />
              <ColouredValueSimple
                v-if="stockItem"
                :value="localProcessCheckSheet.receiveTemp"
                suffix="℃"
                :min="5"
                :max="11"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-chillerTemp"
                :label="$$t('chillerTemp')"
                v-model="localProcessCheckSheet.chillerTemp"
              />
              <ColouredValueSimple
                v-if="stockItem"
                :value="localProcessCheckSheet.chillerTemp"
                suffix="℃"
                :min="8"
                :max="11"
              />
            </v-col>
          </v-row>
          <!--Row 4-->
          <h3>Shucking gutting</h3>
          <v-row>
            <!--Shucking/Gutting - Start Time-->
            <v-col cols="6">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-shuckingGuttingStartTime"
                :label="$$t('shuckingGuttingStartTime')"
                v-model="localProcessCheckSheet.shuckingGuttingStartTime"
              />
            </v-col>
            <!--Shucking/Gutting - end Time-->
            <v-col cols="6">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-shuckingGuttingEndTime"
                :label="$$t('shuckingGuttingEndTime')"
                v-model="localProcessCheckSheet.shuckingGuttingEndTime"
              />
            </v-col>
          </v-row>
        </div>
      </div>
      <div id="FormProcessCheckSheet-SaltBins" :class="{ dimmed: localProcessCheckSheet.status }">
        <div v-if="!isWet && !isCanned && !isPouches">
          <v-row v-if="localProcessCheckSheet.saltBins">
            <v-col cols="1" offset="4">
              <v-btn
                data-cy="btn-bins-decrease"
                color="success"
                :disabled="localProcessCheckSheet.saltBins.length < 2"
                @click="localProcessCheckSheet.saltBins.splice(-1, 1)"
                >-</v-btn
              >
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="Number of Bins"
                v-model="localProcessCheckSheet.saltBins.length"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn
                data-cy="btn-bins-increase"
                color="success"
                @click="localProcessCheckSheet.saltBins.push({})"
                >+</v-btn
              >
            </v-col>
          </v-row>
          <div background-color="success" v-if="stockItem">
            <!--Row 5-->
            <v-row>
              <!--Salting, 10% cultivated -->
              <v-col background-color="primary" cols="12" v-if="stockItem.type == 'Wild'">
                <h1>Salting, 14% Wild</h1>
              </v-col>
              <v-col background-color="primary" cols="12" v-else>
                <h1>Salting, 10% Cultivated</h1>
              </v-col>
            </v-row>
            <!-- Row 6-->
            <v-row>
              <!--Meat + Blood Weight in kg-->
              <v-col cols="4">
                <h2>Meat + Blood Weight (kg)</h2>
              </v-col>
              <!--Salt Bins-->
              <v-col
                cols="4"
                v-for="(bin, index) in localProcessCheckSheet.saltBins"
                :key="`bin-${index + 1}`"
              >
                <v-text-field
                  background-color="#B0BEC5"
                  filled
                  :data-cy="`FormProcessCheckSheet-saltBin${index}Combo`"
                  :label="`Salt Bin ${index + 1}`"
                  v-model="bin.saltBinCombo"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <ColouredValue
                  v-if="stockItem"
                  :value="totalSaltBinCombo"
                  :compare="stockItem.receivedMass"
                  suffix="%"
                  :min="53"
                  :max="60"
                />
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="!isWet && !isCanned && !isPouches">
          <!-- Row 7-->
          <v-row v-if="stockItem">
            <!--Weight of salt in kg-->
            <v-col cols="4">
              <h2>Weight of Salt (kg)</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <v-text-field
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}Salt`"
                :label="`Salt Bin ${index + 1}`"
                v-model="bin.saltBinSalt"
              >
              </v-text-field>
              <ColouredValue
                  v-if="stockItem.type === 'Wild'"
                  :value="bin.saltBinSalt"
                  :compare="bin.saltBinCombo"
                  suffix="%"
                  :min="13.5"
                  :max="14.5"
                />
              <ColouredValue
                  v-else
                  :value="bin.saltBinSalt"
                  :compare="bin.saltBinCombo"
                  suffix="%"
                  :min="9.5"
                  :max="10.5"
                />
            </v-col>
          </v-row>
          <v-row v-if="stockItem">
            <v-col cols="12">
              <ColouredValue
                v-if="stockItem.type === 'Wild'"
                :value="totalSaltBinSalt"
                :compare="totalSaltBinCombo"
                suffix="%"
                :min="13.5"
                :max="14.5"
              />
              <ColouredValue
                v-else
                :value="totalSaltBinSalt"
                :compare="totalSaltBinCombo"
                suffix="%"
                :min="9.5"
                :max="10.5"
              />
            </v-col>
          </v-row>
          <!-- Row 8-->
          <v-row>
            <!--Salt Code-->
            <v-col cols="4">
              <h2>Salt Code</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <v-text-field
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}SaltCode`"
                :label="`Salt Bin ${index + 1}`"
                v-model="bin.saltBinSaltCode"
              />
            </v-col>
          </v-row>
          <!-- Row 9-->
          <v-row>
            <!--Salt Start Time-->
            <v-col cols="4">
              <h2>Start Time</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <TimeField
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}StartTime`"
                :label="`Salt Bin ${index + 1}`"
                v-model="bin.saltBinStartTime"
              />
            </v-col>
          </v-row>
          <!-- Row 10-->
          <v-row>
            <!--Salt End Time-->
            <v-col cols="4">
              <h2>End Time</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <TimeField
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}EndTime`"
                :label="`Salt Bin ${index + 1}`"
                v-model="bin.saltBinEndTime"
              />
              <ColouredValueTime
                :start="bin.saltBinStartTime"
                :end="bin.saltBinEndTime"
                :min="110"
                :max="130"
              />
            </v-col>
          </v-row>
          <!-- Row 11-->
          <v-row>
            <!--Salt End Meat Temp-->
            <v-col cols="4">
              <h2>End Meat Temperature °c</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <v-text-field
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}MeatTemp`"
                :label="`Salt Bin ${index + 1} Meat Temp`"
                v-model="bin.saltBinEndMeatTemp"
              />
            </v-col>
          </v-row>
          <br />
          <!-- Row 12-->
          <v-row>
            <v-col cols="12">
              <!--1st machine wash-->
              <h1>First Machine Wash</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>Start Time</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <TimeField
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${
                  index + 1
                }FirstMachineWashStart`"
                :label="`Salt Bin ${index + 1} Start`"
                v-model="bin.firstMachineWashStart"
              />
            </v-col>
          </v-row>
          <!-- Row 13-->
          <div class="blue-grey mb-10 lighten-2">
            <v-row>
              <v-col cols="4">
                <h2>End Time</h2>
              </v-col>
              <!--Salt Bins-->
              <v-col
                cols="4"
                v-for="(bin, index) in localProcessCheckSheet.saltBins"
                :key="`bin-${index + 1}`"
              >
                <TimeField
                  background-color="#B0BEC5"
                  filled
                  :label="`Salt Bin ${index + 1} End`"
                  v-model="bin.firstMachineWashEnd"
                />
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="4">
              <h2>Total Time</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col
              cols="4"
              v-for="(bin, index) in localProcessCheckSheet.saltBins"
              :key="`bin-${index + 1}`"
            >
              <!-- <TotalTimeField
                background-color="#B0BEC5"
                filled
                :data-cy="`FormProcessCheckSheet-saltBin${index + 1}FirstMachineWashStart`"
                :label="`Salt Bin ${index + 1} Total`"
                v-model="bin.firstMachineWashTotalTime"
                :startTime="bin.firstMachineWashStart"
                :endTime="bin.firstMachineWashEnd"
              /> -->
              <ColouredValueTime
                v-if="stockItem"
                :value="bin.firstMachineWashTotalTime"
                suffix="mins"
                :start="bin.firstMachineWashStart"
                :end="bin.firstMachineWashEnd"
                :min="0"
                :max="11"
              />
            </v-col>
          </v-row>
          <div class="blue-grey mb-10 lighten-5">
            <!-- Row 14-->
            <v-row>
              <v-col cols="4">
                <h2>End Meat Temp (°c)</h2>
              </v-col>
              <!--Salt Bins-->
              <v-col
                cols="4"
                v-for="(bin, index) in localProcessCheckSheet.saltBins"
                :key="`bin-${index + 1}`"
              >
                <v-text-field
                  background-color="#B0BEC5"
                  filled
                  :label="`Salt Bin ${index + 1}`"
                  v-model="bin.firstMachineWashEndTemp"
                />
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="!isCanned && !isPouches" class="blue-grey mb-10 lighten-5">
            <h2 v-if="stockItem.stockType === 'Wet'">Meat + Blood Weight (kg)</h2>
          <v-row v-if="stockItem.stockType === 'Wet'">
            <v-col cols="3">
              <NumberTextField
                background-color="#B0BEC5"
                filled
                data-cy="FormProcessCheckSheet-totalWetMeatAndBloodWeight"
                :value="formatNumber(localProcessCheckSheet.totalWetMeatAndBloodWeight)"
                disabled
              />
            </v-col>
          </v-row>
          <!-- Row 14-->
          <v-row>
            <v-col cols="12">
              <h2>Total Out of Salt Weight</h2>
            </v-col>
            <!--Salt Bins-->
            <v-col cols="3" v-if="!isUndefined && !isWet && !isDry">
              <v-text-field
                background-color="#B0BEC5"
                filled
                data-cy="FormProcessCheckSheet-totalOutOfSaltWeightCanned"
                v-model="localProcessCheckSheet.totalOutOfSaltWeightCanned"
                label="Canned"
              />
            </v-col>
            <v-col cols="3" v-if="isUndefined || isWet && !isDry">
              <v-text-field
                background-color="#B0BEC5"
                filled
                data-cy="FormProcessCheckSheet-totalOutOfSaltWeightWet"
                v-model="localProcessCheckSheet.totalOutOfSaltWeightWet"
                label="Wet"
              />
            </v-col>
            <v-col cols="3" v-if="isUndefined || isDry">
              <v-text-field
                background-color="#B0BEC5"
                filled
                data-cy="FormProcessCheckSheet-totalOutOfSaltWeightDry"
                v-model="localProcessCheckSheet.totalOutOfSaltWeightDry"
                label="Dry"
              />
            </v-col>
            <v-col cols="3" v-if="!isUndefined && !isWet && !isDry">
              <v-text-field
                background-color="#B0BEC5"
                filled
                data-cy="FormProcessCheckSheet-totalOutOfSaltWeightPouches"
                v-model="localProcessCheckSheet.totalOutOfSaltWeightPouches"
                label="Pouches"
              />
            </v-col>
            <v-col cols="3">
              <ColouredValue
                v-if="stockItem"
                :value="totalOutOfSaltWeight"
                :compare="localProcessCheckSheet.deliveryWeight"
                suffix="%"
                :min="31"
                :max="36"
              />
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="!isUndefined && !isCanned && !isPouches">
        <div
          id="FormProcessCheckSheet-OutOfSalt"
          v-if="!isCanned && !isPouches"
          :class="{ dimmed: localProcessCheckSheet.status !== 'Out of Salt' }"
        >
          <v-row>
            <v-col cols="2">
              <h2>Freshwater Soak</h2>
            </v-col>
            <v-col cols="2">
              <DateField
                filled
                data-cy="FormProcessCheckSheet-freshWaterSoakStartDate"
                label="Start Date"
                v-model="localProcessCheckSheet.freshWaterSoakStartDate"
              />
            </v-col>
            <v-col cols="2">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-freshWaterSoakStartTime"
                label="Start Time"
                v-model="localProcessCheckSheet.freshWaterSoakStartTime"
              />
            </v-col>
            <v-col cols="2">
              <DateField
                filled
                data-cy="FormProcessCheckSheet-freshWaterSoakEndDate"
                label="End Date"
                v-model="localProcessCheckSheet.freshWaterSoakEndDate"
              />
            </v-col>
            <v-col cols="2">
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-freshWaterSoakEndTime"
                label="End Time"
                v-model="localProcessCheckSheet.freshWaterSoakEndTime"
              />
            </v-col>
            <v-col cols="2">
              <TotalTimeHoursField
                filled
                readonly
                data-cy="FormProcessCheckSheet-freshWaterSoakTotalTime"
                label="Total Time"
                v-model="localProcessCheckSheet.freshWaterSoakTotalTime"
                :startTime="localProcessCheckSheet.freshWaterSoakStartTime"
                :endTime="localProcessCheckSheet.freshWaterSoakEndTime"
              />
              <ColouredValueTotalTime
                :value="localProcessCheckSheet.freshWaterSoakTotalTime"
                v-if="stockItem"
                :min="4"
                :max="7"
              />
            </v-col>
          </v-row>
          <div v-if="!isDry" class="blue-grey mb-10 lighten-4">
            <v-row>
              <v-col cols="4">
                <h2>Beak Cutting</h2>
              </v-col>
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-beakCuttingStartTime"
                :label="$$t('beakCuttingStartTime')"
                v-model="localProcessCheckSheet.beakCuttingStartTime"
              />
              <TimeField
                filled
                data-cy="FormProcessCheckSheet-beakCuttingEndTime"
                :label="$$t('beakCuttingEndTime')"
                v-model="localProcessCheckSheet.beakCuttingEndTime"
              />
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-beakCuttingTemp"
                label="Beak Cutting End Meat Temp"
                v-model="localProcessCheckSheet.beakCuttingTemp"
              />
            </v-row>
          </div>
          <div class="mt-10 mb-5">
            <v-row>
              <v-col cols="4">
                <h2>2nd machine wash</h2>
              </v-col>
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-secondMachineWashTemp"
                label="Second Machine Wash End Meat Temp"
                v-model="localProcessCheckSheet.secondMachineWashTemp"
              />
            </v-row>
            <SignVerification
              role="Operator"
              title="Signed by"
              v-model="localProcessCheckSheet.secondMachineWashSignature"
            />
          </div>
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn
                block
                color="success"
                :loading="isLoading"
                @click="handover('Second Machine Wash')"
                >Handover</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div
          id="FormProcessCheckSheet-SecondMachineWash"
          :class="{
            dimmed: localProcessCheckSheet.status !== 'Second Machine Wash',
          }"
        >
          <div class="blue-grey mb-10 lighten-4">
            <v-row>
              <v-col cols="2">
                <h2>Wash / Scrub</h2>
              </v-col>
              <v-col cols="2">
                <DateField
                  filled
                  data-cy="FormProcessCheckSheet-washScrubStartDate"
                  label="Start Date"
                  v-model="localProcessCheckSheet.washScrubStartDate"
                />
              </v-col>
              <v-col cols="2">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-washScrubStartTime"
                  label="Start Time"
                  v-model="localProcessCheckSheet.washScrubStartTime"
                />
              </v-col>
              <v-col cols="2">
                <DateField
                  filled
                  data-cy="FormProcessCheckSheet-washScrubEndDate"
                  label="End Date"
                  v-model="localProcessCheckSheet.washScrubEndDate"
                />
              </v-col>
              <v-col cols="2">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-washScrubEndTime"
                  label="End Time"
                  v-model="localProcessCheckSheet.washScrubEndTime"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-washScrubEndMeatTemp"
                  :label="$$t('washScrubEndMeatTemp')"
                  v-model="localProcessCheckSheet.washScrubEndMeatTemp"
                />
              </v-col>
            </v-row>
          </div>
          <div class="mt-10 mb-10" v-if="!isDry">
            <v-row>
              <v-col cols="4">
                <h2>Meat Mass</h2>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-avgPieceWeightCans"
                  :label="$$t('avgPieceWeightCans')"
                  v-model="localProcessCheckSheet.avgPieceWeightCans"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-avgPieceWeightPouches"
                  :label="$$t('avgPieceWeightPouches')"
                  v-model="localProcessCheckSheet.avgPieceWeightPouches"
                />
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="!isDry" :class="{
            dimmed: localProcessCheckSheet.status !== 'Second Machine Wash',
          }"
          class="blue-grey mb-10 lighten-4">
          <v-row>
            <!-- <v-col cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-meatMassBeforeProcessingDry"
                label="Dried Meat Mass Before Processing (kg)"
                v-model="localProcessCheckSheet.meatMassBeforeProcessingDry"
              />
            </v-col> -->
            <v-col cols="4">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-meatMassBeforeProcessingCans"
                :label="$$t('meatMassBeforeProcessingCans')"
                v-model="localProcessCheckSheet.meatMassBeforeProcessingCans"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-meatMassBeforeProcessingPouches"
                :label="$$t('meatMassBeforeProcessingPouches')"
                v-model="localProcessCheckSheet.meatMassBeforeProcessingPouches"
              />
            </v-col>
            <v-col cols="4">
              <ColouredValueSimple
                :value="meatMassBeforeProcessing"
                v-if="stockItem"
                :min="29"
                :max="35"
                suffix="% "
              />
            </v-col>
          </v-row>
        </div>
        <div :class="{
            dimmed: localProcessCheckSheet.status !== 'Second Machine Wash',
          }"
        >
          <SignVerification
            role="Operator"
            title="Signed by"
            v-model="localProcessCheckSheet.requestedBySignature"
          />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn
                block
                color="success"
                :loading="isLoading"
                @click="handover('Canning/Pouches')"
                >Handover</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
      <div
          id="FormProcessCheckSheet-Canning-Pouches"
          v-if="!isWet && !isUndefined && !isDry"
          :class="{ dimmed: localProcessCheckSheet.status !== 'Canning/Pouches' }"
        >
        <v-row v-if="!isWet">
          <v-col cols="12">
            <!--1st machine wash-->
            <h1>Canning / Pouches</h1>
          </v-col>
        </v-row>
        <div v-if="!isWet">
          <v-row>
            <v-col cols="4">
              <h2>Processing Date</h2>
            </v-col>
            <v-col cols="4" v-if="isCanned">
              <AdminTextField
                filled
                data-cy="FormProcessCheckSheet-processingDateCans"
                :label="$$t('processingDateCans')"
                v-model="localProcessCheckSheet.processingDateCans"
              />
            </v-col>
            <v-col cols="4" v-if="isPouches">
              <AdminTextField
                filled
                data-cy="FormProcessCheckSheet-processingDatePouches"
                :label="$$t('processingDatePouches')"
                v-model="localProcessCheckSheet.processingDatePouches"
              />
            </v-col>
          </v-row>
          <div class="blue-grey mb-10 lighten-4">
            <v-row>
              <v-col cols="4">
                <h2>Start Time</h2>
              </v-col>
              <v-col v-if="isCanned" cols="4">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-startTimeCans"
                  :label="$$t('startTimeCans')"
                  v-model="localProcessCheckSheet.startTimeCans"
                />
              </v-col>
              <v-col v-if="isPouches" cols="4">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-startTimePouches"
                  :label="$$t('startTimePouches')"
                  v-model="localProcessCheckSheet.startTimePouches"
                />
              </v-col>
            </v-row>
          </div>
          <div class="">
            <v-row>
              <v-col cols="4">
                <h2>End Time</h2>
              </v-col>
              <v-col v-if="isCanned" cols="4">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-endTimeCans"
                  :label="$$t('endTimeCans')"
                  v-model="localProcessCheckSheet.endTimeCans"
                />
              </v-col>
              <v-col v-if="isPouches" cols="4">
                <TimeField
                  filled
                  data-cy="FormProcessCheckSheet-endTimePouches"
                  :label="$$t('endTimePouches')"
                  v-model="localProcessCheckSheet.endTimePouches"
                />
              </v-col>
            </v-row>
          </div>
          <div class="blue-grey mb-10 lighten-4">
            <v-row>
              <v-col cols="4">
                <h2>End Meat Temp</h2>
              </v-col>
              <v-col v-if="isCanned" cols="4">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-endMeatTempCans"
                  :label="$$t('endMeatTempCans')"
                  v-model="localProcessCheckSheet.endMeatTempCans"
                />
              </v-col>
              <v-col v-if="isPouches" cols="4">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-endMeatTempPouches"
                  :label="$$t('endMeatTempPouches')"
                  v-model="localProcessCheckSheet.endMeatTempPouches"
                />
              </v-col>
            </v-row>
          </div>
          <div class="">
            <v-row>
              <v-col cols="3">
                <h2>Damaged Pieces (kg)</h2>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-damagedPiecesCount"
                  label="Count"
                  v-model="localProcessCheckSheet.damagedPiecesCount"
                />
              </v-col>
              <v-col v-if="isCanned" cols="3">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-damagedPiecesCans"
                  :label="$$t('damagedPiecesCans')"
                  v-model="localProcessCheckSheet.damagedPiecesCans"
                />
              </v-col>
              <v-col v-if="isPouches" cols="3">
                <v-text-field
                  filled
                  data-cy="FormProcessCheckSheet-damagedPiecesPouches"
                  :label="$$t('damagedPiecesPouches')"
                  v-model="localProcessCheckSheet.damagedPiecesPouches"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div id="FormProcessCheckSheet-Quality" v-if="!isUndefined && !isWet && !isDry"
          :class="{ dimmed: localProcessCheckSheet.status !== 'Canning/Pouches' }">
        <hr />
        <div class="blue-grey mb-10 lighten-4">
          <v-row>
            <v-col cols="4">
              <h2>Quality Defects (Shell, dirt, damage)</h2>
            </v-col>
            <v-col cols="4">
              <v-select
                v-if="isCanned"
                :items="['Yes', 'No']"
                filled
                data-cy="FormProcessCheckSheet-qualityDefectsCans"
                :label="$$t('qualityDefectsCans')"
                v-model="localProcessCheckSheet.qualityDefectsCans"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                v-if="isPouches"
                :items="['Yes', 'No']"
                filled
                data-cy="FormProcessCheckSheet-qualityDefectsPouches"
                :label="$$t('qualityDefectsPouches')"
                v-model="localProcessCheckSheet.qualityDefectsPouches"
              />
            </v-col>
          </v-row>
        </div>
        <div class="blue-grey mb-10 lighten-4">
          <h2>Drained Weight</h2>
          <v-row v-if="localProcessCheckSheet.drainedWeights">
            <v-col cols="1" offset="4">
              <v-btn
                data-cy="btn-bins-decrease"
                color="success"
                :disabled="localProcessCheckSheet.drainedWeights.length < 2"
                @click="localProcessCheckSheet.drainedWeights.splice(-1, 1)"
                >-</v-btn
              >
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="Number of Drain Weights"
                v-model="localProcessCheckSheet.drainedWeights.length"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn
                data-cy="btn-bins-increase"
                color="success"
                @click="localProcessCheckSheet.drainedWeights.push({})"
                >+</v-btn
              >
            </v-col>
          </v-row>
          <v-row
            v-for="(
              drainedWeight, index
            ) in localProcessCheckSheet.drainedWeights"
            :key="index"
          >
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-drainedWeight"
                :label="$$t('drainedWeight')"
                v-model="drainedWeight.weight"
              />
            </v-col>
            <v-col cols="4">
              <!-- <v-text-field
            filled
            data-cy="FormProcessCheckSheet-drainedWeightCans"
            label="Drained Weight Cans"
            v-model="drainedWeight.cans"
          /> -->
            </v-col>
          </v-row>
        </div>
        <!-- Row 12-->
        <v-row>
          <v-col cols="12">
            <h1>Inspections</h1>
          </v-col>
        </v-row>
        <div class="">
          <v-row>
            <v-col cols="3">
              <h2>Inspection 1 INGO Weight</h2>
            </v-col>
            <v-col cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionCanOneCount"
                label="Piece Count"
                v-model="localProcessCheckSheet.inspectionCanOneCount"
              />
            </v-col>
            <v-col v-if="isCanned" cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionCanOneWeight"
                :label="$$t('inspectionCanOneWeight')"
                v-model="localProcessCheckSheet.inspectionCanOneWeight"
              />
            </v-col>
            <v-col v-if="isPouches" cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionPouchOneWeight"
                :label="$$t('inspectionPouchOneWeight')"
                v-model="localProcessCheckSheet.inspectionPouchOneWeight"
              />
            </v-col>
          </v-row>
        </div>
        <div class="blue-grey mb-10 lighten-4">
          <v-row>
            <v-col cols="3">
              <h2>Inspection 2 INGO Weight</h2>
            </v-col>
            <v-col cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionCanTwoCount"
                label="Piece Count"
                v-model="localProcessCheckSheet.inspectionCanTwoCount"
              />
            </v-col>
            <v-col v-if="isCanned" cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionCanTwoWeight"
                :label="$$t('inspectionCanTwoWeight')"
                v-model="localProcessCheckSheet.inspectionCanTwoWeight"
              />
            </v-col>
            <v-col v-if="isPouches" cols="3">
              <v-text-field
                filled
                data-cy="FormProcessCheckSheet-inspectionPouchTwoWeight"
                :label="$$t('inspectionPouchTwoWeight')"
                v-model="localProcessCheckSheet.inspectionPouchTwoWeight"
              />
            </v-col>
          </v-row>
        </div>
        <br />
        <v-text-field
          filled
          data-cy="FormProcessCheckSheet-comments"
          :label="$$t('comments')"
          v-model="localProcessCheckSheet.comments"
        />
        <v-text-field
          filled
          data-cy="FormProcessCheckSheet-correctiveActions"
          :label="$$t('correctiveActions')"
          v-model="localProcessCheckSheet.correctiveActions"
        />
        <SignVerification
          role="Operator"
          title="Signed by"
          v-model="localProcessCheckSheet.qualitySignature"
        />
        <v-row>
          <v-col cols="12" class="mb-10">
            <v-btn
              block
              color="success"
              :loading="isLoading"
              @click="handover('Ready to be verified')"
              >Handover</v-btn
            >
          </v-col>
        </v-row>
      </div>
      <br />
      <div id="FormProcessCheckSheet-Verify" v-if="!isUndefined">
        <div :class="{ dimmed: localProcessCheckSheet.status !== 'Ready to be verified' }">
        <span class="text-h5 text-left">Verified By</span>
        <hr class="mb-5 mt-5" />
          <SignVerification
            role="Operator"
            title="Verified by"
            v-model="localProcessCheckSheet.verifiedBySignature"
          />
          <br />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success"
                :loading="isLoading" @click="handover('Ready for NRCS')"
                >Handover</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <div :class="{ dimmed: localProcessCheckSheet.status !== 'Ready for NRCS' }">
          <SignVerification
            role="Nrcs"
            title="NRCS Inspector"
            v-model="localProcessCheckSheet.ncrsSignature"
          />
          <br />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn :loading="isLoading" block color="success" @click="handover('Completed')"
                >Completed</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
      <!--Cancel button-->
      <div class="d-flex justify-end mb-6">
        <v-btn
          color="default"
          outlined
          class="ml-4 btn-cancel"
          @click="cancel"
          data-cy="FormProcessCheckSheet-button-cancel"
        >
          {{ $t("common.buttons.cancel") }}
        </v-btn>
        <!--Submit button-->
        <v-btn
          color="primary"
          type="submit"
          class="ml-4"
          :loading="isLoading"
          data-cy="FormProcessCheckSheet-button-save"
        >
          {{ $t("common.buttons.save") }}
        </v-btn>
      </div>
      <v-btn
        @click="removeDimmed"
        class="mt-2 mb-5"
        color="primary"
        v-if="isAdmin"
      >
        Admin Override
      </v-btn>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import CardApproval from './CardApproval.vue';
import formChecklist from './formChecklist';
import SignVerification from './SignVerification.vue';
import ColouredValue from './ColouredValue.vue';
import ColouredValueSimple from './ColouredValueSimple.vue';
import ColouredValueTime from './ColouredValueTime.vue';
import ColouredValueTotalTime from './ColouredValueTotalTime.vue';
import TotalTimeHoursField from './TotalTimeHoursField.vue';
import DateField from './DateField.vue';
import TimeField from './TimeField.vue';
import AdminTextField from './AdminTextField.vue';
import NumberTextField from './NumberTextField.vue';

const { ToWords } = require('to-words');

export default {
  name: 'FormProcessCheckSheet',
  module: 'ProcessCheckSheet',
  components: {
    AdminTextField,
    CardApproval,
    ColouredValue,
    ColouredValueSimple,
    ColouredValueTime,
    ColouredValueTotalTime,
    DateField,
    NumberTextField,
    SignVerification,
    TotalTimeHoursField,
    TimeField,
  },
  mixins: [formChecklist],
  props: {
    /**
     * Set the text box value. Default: undefined,
     */
    ProcessCheckSheet: {
      type: Object,
      default: undefined,
    },
    /**
     * Set the stock item. Default: undefined,
     */
    stockItem: {
      type: Object,
      default: () => {},
    },
    isUndefined: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      blackBorder: { border: 'black 3px solid' },
      /**
       * Hold form validation state
       */
      valid: false,
      /**
       * Local value used for property localProcessCheckSheet
       */
      localProcessCheckSheet: {
        saltBins: [{}],
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isInRole']),
    isAdmin() {
      return this.isInRole('Administrators');
    },
    bins() {
      const toWords = new ToWords();
      const result = [];
      for (
        let index = 1;
        index <= this.localProcessCheckSheet.saltBins?.length;
        index += 1
      ) {
        result.push(toWords.convert(index));
      }
      return result;
    },
    isDry() {
      const { stockItem } = this;
      return stockItem.stockType === 'Dry';
    },
    isWet() {
      const { stockItem } = this;
      return stockItem.stockType === 'Wet' && stockItem.parentStockItemId;
    },
    isCanned() {
      const { stockItem } = this;
      return stockItem.stockType === 'Canned' && stockItem.parentStockItemId;
    },
    isPouches() {
      const { stockItem } = this;
      return stockItem.stockType === 'Pouches' && stockItem.parentStockItemId;
    },
    meatMassBeforeProcessing() {
      // eslint-disable-next-line max-len
      const val1 = parseFloat(
        this.localProcessCheckSheet.meatMassBeforeProcessingCans ?? '0',
      );
      const val2 = parseFloat(
        this.localProcessCheckSheet.meatMassBeforeProcessingPouches ?? '0',
      );
      const val4 = parseFloat(
        this.localProcessCheckSheet.meatMassBeforeProcessingDry ?? '0',
      );
      const val3 = parseFloat(
        this.localProcessCheckSheet.deliveryWeight ?? '0',
      );
      return parseFloat((((val1 + val2 + val4) / val3) * 100).toFixed(1));
    },
    totalOutOfSaltWeight() {
      // eslint-disable-next-line max-len
      const canned = parseFloat(
        this.localProcessCheckSheet.totalOutOfSaltWeightCanned ?? '0',
      );
      const pouches = parseFloat(
        this.localProcessCheckSheet.totalOutOfSaltWeightPouches ?? '0',
      );
      const dry = parseFloat(
        this.localProcessCheckSheet.totalOutOfSaltWeightDry ?? '0',
      );
      const wet = parseFloat(
        this.localProcessCheckSheet.totalOutOfSaltWeightWet ?? '0',
      );
      // console.debug({
      //   canned, pouches, dry, wet,
      // });
      switch (this.stockItem?.stockType) {
        case 'Undefined':
          return dry + wet;
        case 'Wet':
          return wet;
        default:
          return canned + pouches + dry + wet;
      }
    },
    totalSaltBinCombo() {
      const totalSaltBinCombo = this.localProcessCheckSheet.saltBins.reduce(
        (total, obj) => total + parseFloat(obj.saltBinCombo ?? '0'),
        0,
      );
      return totalSaltBinCombo;
    },
    totalSaltBinSalt() {
      const totalSaltBinSalt = this.localProcessCheckSheet.saltBins.reduce(
        (total, obj) => total + parseFloat(obj.saltBinSalt ?? '0'),
        0,
      );
      return totalSaltBinSalt;
    },
  },
  watch: {
    ProcessCheckSheet() {
      this.localProcessCheckSheet = this.ProcessCheckSheet;
    },
  },
  async mounted() {
    this.usernames = await this.LOAD_usernames;
    this.localProcessCheckSheet = this.ProcessCheckSheet;
    this.$forceUpdate();
    setTimeout(() => {
      this.$forceUpdate();
    }, 500);
  },
  methods: {
    getTotal(name) {
      let total = 0;
      for (
        let index = 0;
        index < this.localProcessCheckSheet.saltBins.length;
        index += 1
      ) {
        const prop = `saltBin${this.bins[index]}${name}`;
        const element = this.localProcessCheckSheet[prop];
        total += element;
      }
      return total;
    },
    removeDimmed() {
      const elements = document.getElementsByClassName('dimmed');
      elements.forEach((e) => {
        e.classList.remove('dimmed');
      });
    },
    handover(status) {
      this.localProcessCheckSheet.status = status;
      this.$emit('save', this.localProcessCheckSheet);
    },
    handoverUpdate() {
      this.localProcessCheckSheet.status = '';
      this.$emit('update', this.localProcessCheckSheet);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localProcessCheckSheet);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormProcessCheckSheet example

'''js
<FormProcessCheckSheet :ProcessCheckSheet="ProcessCheckSheet" />
'''
</docs>
<style>
.dimmed {
  opacity: 0.4;
}
</style>
